import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

const MedicalDisclaimer = ({ className = '' }) => {
  return (
    <div className={`w-full py-3 px-4 ${className}`}>
      <div className="max-w-4xl mx-auto flex justify-center">
        <Link 
          to="/medical-disclosure"
          className="inline-flex items-center gap-2 text-xs text-gray-500 hover:text-primary transition-colors bg-gray-100 hover:bg-gray-200 px-3 py-2 rounded-full"
          data-testid="medical-disclaimer-button"
        >
          <AlertTriangle className="w-3 h-3" />
          <span>Medical Disclaimer</span>
        </Link>
      </div>
    </div>
  );
};

export default MedicalDisclaimer;
